import React from 'react';
import Slider from 'rc-slider';

import FormRadio from 'components/forms/FormRadio';

export default class CmsElementGrid extends React.Component {
  render() {
    const {
      intl: { messages },
      getParamValue,
      setParam,
    } = this.props;

    const paddingTop = getParamValue('paddingTop', 0);
    const paddingBottom = getParamValue('paddingBottom', 0);

    const smPaddingTop = getParamValue('smPaddingTop', paddingTop);
    const smPaddingBottom = getParamValue('smPaddingBottom', paddingBottom);

    return (
      <>
        <div className="form-group-attached">
          <p>
            <b>{messages.cms_grid}</b>
          </p>

          <FormRadio
            label={messages.grid_fluid}
            options={[{ label: messages.yes, value: 'yes' }, { label: messages.no, value: 'no' }]}
            onChange={setParam}
            value={getParamValue('isFluid', 'yes')}
            name="isFluid"
          />
          <div className="form-group form-group-default">
            <label>
              {messages.padding_top} {paddingTop + 'px'}
            </label>
            <Slider value={paddingTop} min={0} max={150} step={5} onChange={value => setParam('paddingTop', value)} />
          </div>
          <div className="form-group form-group-default">
            <label>
              {messages.padding_bottom} {paddingBottom + 'px'}
            </label>
            <Slider
              value={paddingBottom}
              min={0}
              max={150}
              step={5}
              onChange={value => setParam('paddingBottom', value)}
            />
          </div>
        </div>

        <div className="form-group-attached m-t-15">
          <div className="form-group form-group-default">
            <label>
              {messages.padding_top} {messages.mobile_phones + '/' + messages.tablets} {smPaddingTop + 'px'}
            </label>
            <Slider
              value={smPaddingTop}
              min={0}
              max={150}
              step={5}
              onChange={value => setParam('smPaddingTop', value)}
            />
          </div>
          <div className="form-group form-group-default">
            <label>
              {messages.padding_bottom} {messages.mobile_phones + '/' + messages.tablets} {smPaddingBottom + 'px'}
            </label>
            <Slider
              value={smPaddingBottom}
              min={0}
              max={150}
              step={5}
              onChange={value => setParam('smPaddingBottom', value)}
            />
          </div>
        </div>
      </>
    );
  }
}
